module.exports = {
    API_URL: process.env.VUE_APP_API_URL,
    API_KEY: process.env.VUE_APP_API_KEY,
    SENTRY_DNS: process.env.VUE_APP_SENTRY_DNS
}